<template>
  <el-card shadow="never">
    <div v-html="about"></div>
  </el-card>
</template>

<script>
  import axios from "axios"

  export default {
    name: "about-our-organisation",
    data() {
      return {
        about: ''
      }
    },
    async mounted() {
      await this.getAbout()
    },
    methods: {
      async getAbout() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/companies/custom-fields?companyId=${this.$route.query.companyId}`)
          this.about = data.item.about ? data.item.about : 'There is no information'
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error)
          loader.hide()
        }
      },
    }
  }
</script>